
<div class="wrap-text">
  {{ user.name }} | {{ user.entity.name }}
</div>
